module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-15.787956c2.png";